import React, { useState } from "react";
import { Fade } from "react-awesome-reveal";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from "swiper/modules";

import "swiper/swiper-bundle.css";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default function Certificate({ data }) {
  const [zoomedImage, setZoomedImage] = useState(null);

  return (
    <section className="container mx-auto px-4 py-10">
      <Fade direction="up">
        <h1 className="text-6xl text-green-700 text-center font-bold mb-6">
          Certifications
        </h1>
      </Fade>
      <Fade direction="up" delay={500}>
        <p className="font-light text-xl text-green-500 text-center mb-6">
          We are proudly certified by multiple leading companies, ensuring the
          highest standards of quality and excellence.
        </p>
      </Fade>

      <Swiper
        modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
        className="mySwiper"
        loop={true}
        navigation={true}
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        slidesPerView={1}
        breakpoints={{
          640: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
      >
        {data.map((item) => (
          <SwiperSlide key={item.id}>
            <div className="flex flex-col items-center bg-green-50 rounded-2xl shadow-2xl border border-green-300 px-8 py-6 mx-4 mb-8">
              <div className="flex flex-col items-center mb-5">
                <img
                  src={item.imageUrl}
                  alt={item.name}
                  className="w-60 h-60 object-contain rounded-lg shadow-lg transition-transform duration-300 hover:scale-150 cursor-pointer"
                  onClick={() => setZoomedImage(item.imageUrl)}
                />
                <h2 className="text-green-700 text-2xl font-bold mt-4">
                  {item.name}
                </h2>
                <p className="font-light text-gray-500">{item.company}</p>
              </div>
              <p className="font-light text-lg text-gray-600 text-center">
                {item.testimoni}
              </p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Modal for zoomed image */}
      {zoomedImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50"
          onClick={() => setZoomedImage(null)}
        >
          <img
            src={zoomedImage}
            alt="Zoomed"
            className="max-w-full max-h-[90vh] rounded-lg shadow-2xl"
          />
        </div>
      )}
    </section>
  );
}
